module.exports = __webpack_public_path__ + "img/animal_fukurou.f6c12e9e.png";